module.exports = __webpack_public_path__ + "static/media/43.17b1abba.JPG";